import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { DriverVaccine } from 'interfaces/driver-vaccines';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess'],
    success: ['data'],
    failure: ['error', 'validationErrors'],
    reset: [],
  },
  { prefix: 'FETCH_VACCINE_CERTIFICATES_' }
);

export interface FetchVaccineCertificatesState {
  data: DriverVaccine[];
  loading: boolean;
  error: string | null;
  validationErrors: Record<string, any>[];
}

export interface FetchVaccineCertificatesRequest {
  id: number;
  onSuccess?: (driverVaccines: DriverVaccine[]) => void;
}

interface Success {
  data: DriverVaccine[];
}

interface Failure {
  error: string;
  validationErrors: Record<string, any>[];
}

const INITIAL_STATE: FetchVaccineCertificatesState = {
  data: [],
  loading: false,
  error: null,
  validationErrors: [],
};

const request = (state: FetchVaccineCertificatesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchVaccineCertificatesState, action: Success) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchVaccineCertificatesState, action: Failure) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
    validationErrors: { $set: action.validationErrors },
  });

const reset = () => INITIAL_STATE;

export const fetchVaccineCertificates = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchVaccineCertificatesTypes = Types;
export const FetchVaccineCertificatesActions = Creators;
